import Awesomplete from 'awesomplete';
import BaseFeature from '../../foundation/base/base';
import { debounce } from '../../foundation/utilities/debounce';
import { searchTypeaheadTest } from './search-typeahead-api-test';
import { searchTypeahead } from './search-typeahead-api';

const classes = {
	open: 'o-search-navigation--open'
};

const defaultSettings = {
	endpoint: 'perstorp.website.local/sitecore/api/searchapi/typeahead',
	searchPage: '/search?q=',
	dev: false,
	minChars: 1,
	fetchDelay: 250,
	maxItems: 4
};

export default class SearchNavigation extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.body = window.features.dom.body;
		this.initDomCache();
		this.settings = Object.assign({}, defaultSettings, this.parseSettings());

		// Fetch results from API depending on dev
		this.fetchResults = !this.settings.dev ?
			query => searchTypeahead(this.settings.endpoint, query) :
			searchTypeaheadTest;

		this.awesomplete = new Awesomplete(this.dom.searchInput, {
			minChars: this.settings.minChars,
			maxItems: this.settings.maxItems
		});

		// Move input field outside
		this.dom.searchInput.parentNode.parentNode.insertBefore(
			this.dom.searchInput,
			this.dom.searchInput.parentNode
		);

		this.updateResults = debounce(this.updateResults.bind(this), this.settings.fetchDelay);

		this.addEventListeners();
	}

	addEventListeners() {
		this.addEventListener(this.dom.toggle, 'click', (e) => {
			e.preventDefault();
			this.toggle();
		});
		this.addEventListener(this.body, 'click', (e) => {
			if (!this.el.contains(e.target)) this.close();
		});
		this.addEventListener(this.dom.form, 'submit', (e) => {
			e.preventDefault();
			this.submitForm(e);
		});
		this.addEventListener(this.dom.searchInput, 'keyup', (e) => {
			this.handleKeyup(e);
		});
		this.addEventListener(this.dom.searchInput, 'awesomplete-select', (e) => {
			this.handleSelect(e);
		});
	}

	// Get settings from data-attributes
	parseSettings() {
		const settings = this.el.getAttribute('data-settings') || '{}';
		return JSON.parse(settings);
	}

	/*
	*	Search logic
	*/

	handleKeyup(e) {
		const ignoredKeyCodes = [
			13, // return
			27, // esc
			37, // left arrow
			38, // up arrow
			39, // right arrow
			40 // down arrow
		];

		if (ignoredKeyCodes.indexOf(e.keyCode) > -1) {
			return;
		}

		this.updateResults();
	}

	// On click on awesomplete list-item
	handleSelect(e) {
		this.dom.searchInput.value = e.text;
		this.submitForm();
	}

	updateResults() {
		const query = this.dom.searchInput.value;

		if (query.length < this.settings.minChars) {
			return;
		}

		this.fetchResults(query).then((json) => {
			this.awesomplete.list = SearchNavigation.toAwesompleteList(json);
		});
	}

	// Get the input value and search
	submitForm() {
		const query = this.dom.searchInput.value.trim();
		if (!query) return;
		const target = this.settings.searchPage + encodeURIComponent(query);
		window.location.href = target;
	}

	static toAwesompleteList(json) {
		const jsonResult = JSON.parse(json)
		return jsonResult.map(result => ({
			label: `${result.name}`,
			value: result.name
		}));
	}

	/*
	*	Navigation logic
	*/

	toggle() {
		if (this.el.classList.contains(classes.open)) {
			this.close();
		} else {
			this.publish('/header/action/switch');
			this.open();
		}
	}

	open() {
		this.el.classList.add(classes.open);
		this.dom.content.style.maxHeight = this.dom.inner.offsetHeight + 'px';
		setTimeout(() => {
			this.dom.content.style.overflow = 'visible';
		}, 50);
		this.focusInput();
	}

	close() {
		this.dom.content.style.removeProperty('overflow');
		this.dom.content.style.maxHeight = '0px';
		setTimeout(() => {
			this.el.classList.remove(classes.open);
		}, 50);
	}

	focusInput() {
		this.dom.searchInput.focus();
	}
}
